<template>
<div v-if="selected_masters_module">
  <v-row class="mb-6" no-gutters align="center">
      <v-btn
        :icon="$store.state.isMobile"
        :text="!$store.state.isMobile"
        color="indigo accent-3"
        v-on:click="goBack"
      >
        <v-icon :left="!$store.state.isMobile" size="20"
          >mdi-keyboard-backspace</v-icon
        >
        <span v-show="!$store.state.isMobile" style="font-size: 20px;"
          >Back</span
        >
      </v-btn>
      <v-col xs="4" cols="4" md="3" no-gutters>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" class="pa-2 ps-0">
              <h3 class="color-services">{{ selected_masters_module.name }}</h3>
              <v-icon right color="#5c648b">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
              @click="()=> {selected_masters_module = item; $store.state.selected_client_masters_module = item; $store.state.selected_client = null;}"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>

    </v-row>
    <component v-bind:is="selected_masters_module.component"/>
</div>
</template>
<script>
import values from "../../../constants/values";
import GradeList from "./Grade/List/GradeList"
import ClassList from "./Class/List/ClassList";
import ReferralRelationList from "./ReferralRelation/List/ReferralRelationList";
import store from "../../../store"
import RoleList from "./Role/List/RoleList";
import ServiceList from "./Services/ServiceList";
import StepList from "./Steps/StepList";
import { ROUTER_URL } from "../../../constants/urls";
import Helper from "../../../helper";

export default {
    name:"MastersDetails",
    components:{
      GradeList,
      ClassList,
      ReferralRelationList,
      RoleList,
      StepList,
      ServiceList
    },
    data () {
     return{
        routerPath: ROUTER_URL,
        GradeList: GradeList,
        ClassList: ClassList,
        ReferralRelationList: ReferralRelationList,
        RoleList: RoleList,
        ServiceList: ServiceList,
        StepList: StepList,
        $store: store,
        selected_masters_module: null,
        items: values.client_masters_data_tables,
        componentName: ""
      }
    },
    methods:{
      goBack () {
        Helper.goBack();
      },
      changeMastersModule(val){
        this.$store.state.selected_client = null;
        this.$router.push({
          name: this.routerPath.adminPanel.children.clientMastersDetails.name,
          params:{id:val}
        });
      }
    },
    mounted(){
        this.id = this.$route.params.id;
        if(this.$store.state.selected_client_masters_module != null){
          this.selected_masters_module = this.$store.state.selected_client_masters_module;
        }
        else{
          this.selected_masters_module = values.client_masters_data_tables[--this.id]
        }
    },
    watch: {
      $route() {
        this.id = this.$route.params.id;
        this.selected_masters_module = values.client_masters_data_tables[--this.id]
      }
    }
}
</script>